import { Container } from 'components/atoms';
import StatisticListCard from 'components/atoms/statistics/StatisticListCard';
import { ReactNode } from 'react';
import { ILoadingProp } from 'types/components/components.interface';

interface IStatisticsListContainerProps<Item> extends ILoadingProp {
  headerTitle?: ReactNode;
  headerChildren?: ReactNode;
  items?: Item[];
  label: (item: Item) => ReactNode | ReactNode[];
  value: (item: Item) => string;
  onItemClick?: (item: Item) => void;
  children?: ReactNode | ReactNode[];
  classname?: string;
  isHighlighted?: (item: Item) => boolean;
  onFullyScroll?: () => void;
}

const StatisticsListContainer = <Item,>({
  headerTitle,
  items = [],
  label,
  value,
  children,
  headerChildren,
  onItemClick,
  classname = '',
  isHighlighted,
  onFullyScroll,
  loading,
}: IStatisticsListContainerProps<Item>) => {
  return (
    <Container className={`w-full min-h-[320px]  ${classname}`}>
      <Container.Header title={headerTitle} children={headerChildren} />
      {children && <Container.Content>{children}</Container.Content>}

      <Container.Content
        className='h-full gap-0 overflow-auto'
        onFullyScroll={onFullyScroll}
        loading={loading}>
        {items.map((item, index) => (
          <StatisticListCard
            key={index}
            value={value(item)}
            highlighted={isHighlighted ? isHighlighted(item) : index === 0}
            onClick={() => onItemClick && onItemClick(item)}>
            {index + 1}. {label(item)}
          </StatisticListCard>
        ))}
      </Container.Content>
    </Container>
  );
};

export default StatisticsListContainer;
